import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "website-importer-blob2",
  "use": "website-importer-blob2-usage",
  "viewBox": "0 0 85 85",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 85 85\" id=\"website-importer-blob2\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M64.155 24.683c-9.296-9.704-22.588-17.146-34.688-11.272-12.668 6.149-17.53 21.467-14.725 35.258C17.2 60.76 28.692 67.689 40.888 69.57 52.926 71.43 66.045 68.27 71.653 57.45c5.704-11.005 1.068-23.824-7.498-32.767z\" fill=\"#AB80DE\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol